import React from "react"
import PropTypes from 'prop-types'

import "./header.scss"

const Header = ({title, subtitle, image}) => (
    <header className={"sr-header"}>
        <p className={"subtitle"}>The 51st Union World Conference on Lung Health</p>
        {image !== undefined ? image : null}
        {title !== null ? <h1 className={"title"}>{title}</h1> : null}
        {subtitle !== null ?  <p className={"subtitle"}>{subtitle}</p>: null}
    </header>
)

Header.propTypes = {
    title:      PropTypes.string,
    subtitle:   PropTypes.string,
    image:      PropTypes.node,
}

Header.defaultProps = {
    title: "Advancing prevention",
    subtitle: "20-24 october 2020 | Virtual conference",
}

export default Header
